<script lang="ts">
  export let data: HelpGeneralHtmlData;
</script>

<div class="w-full">
  {@html data.content}
</div>
